const SITE_NAME = 'AuraIcon';
const DEFAULT_TITLE = 'AuraIcon - AI iOS & Android App Icon Generator';
const DEFAULT_DESCRIPTION = 'Generate professional, App Store ready icons for iOS and Android in seconds. High-quality, scalable AI icons with transparency and perfect sizing.';
const SITE_URL = 'https://auraicon.ai';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

// React 19 native document metadata support
// These tags are automatically hoisted to <head>
export default function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  ogType = 'website',
  ogImage = DEFAULT_IMAGE,
  noindex = false,
}) {
  const fullTitle = title ? `${title} - ${SITE_NAME}` : DEFAULT_TITLE;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical === '/' ? '' : canonical}` : undefined;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImage} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
}
